<template>
    <div v-if="isMounted">
        <vue-scroll :ops="$ops">
            <div v-loading="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.loading">
                <el-form ref="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam"
                         :label-position="'center'"
                         :model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam"
                         label-width="100px">
                    <el-row :gutter="20">
                        <!--学校选择-->
                        <el-col :span="6">
                            <el-form-item label="学校">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school.name"
                                        :disabled=true
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-form-item label="年级">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.grade.name"
                                        :disabled=true
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <!--考试选择-->
                        <el-col :span="6">
                            <el-form-item label="考试">
                                <el-input style="width:215px"
                                          v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exams.name"
                                          placeholder="输入考试" class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-form-item label="考试时间">
                                <el-date-picker
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exams.date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                        :disabled=true
                                        class="inputWidth">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <!--考试选择-->
                        <el-col :span="6">
                            <el-form-item label="班级">
                                <el-select
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class.schoolClass_id"
                                        filterable
                                        placeholder="请选择"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.schoolClasses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="三总成绩" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainScore"
                                        placeholder="请输入三总成绩"
                                        :disabled=true></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="全科成绩" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumScore"
                                        placeholder="请输入全科成绩"
                                        :disabled=true></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="三总班级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainClassRank"
                                        placeholder="请输入三总班级排名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="三总年级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainGradeRank"
                                        placeholder="请输入班级排名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="三总地区排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainAreaRank"
                                        placeholder="请输入三总地区排名"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="全科班级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumClassRank"
                                        placeholder="请输入全科班级排名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="全科年级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumGradeRank"
                                        placeholder="请输入全科年级排名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="全科地区排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumAreaRank"
                                        placeholder="请输入全科地区排名"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>学科</th>
                                <th>成绩</th>
                                <th>班级排名</th>
                                <th>年级排名</th>
                                <th>区排名</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in $parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.schoolScores"
                                :key="item.id">
                                <td>
                                    <el-input v-model="item.school_exam_subject.subject.name" size="small"
                                              :disabled=true></el-input>
                                </td>
                                <td>
                                    <el-input v-model="item.score" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="item.classRank" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="item.gradeRank" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="item.areaRank" size="small"></el-input>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </el-row>
                </el-form>
            </div>
        </vue-scroll>
        <div class="text-right">
            <el-button type="primary" size="small" @click="handleUpdateSchoolExam()"
                       :loading="$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.button_loading">修 改
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_UpdateMainSchoolScore',
        data() {
            return {
                isMounted: false
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.loading = true;
            this.handleShowStudentExam();
            this.isMounted = true;
        },
        methods: {
            handleShowStudentExam() {
                this.$wApi.send(this.$parentInfo.path, 'showStudentExam', {
                    'exam_id': this.$store.state.modal.data.id,
                });
            },
            // handleCreateExam() {
            //     this.$wApi.send(this.$parentInfo.path, 'initExam');
            // },
            handleUpdateSchoolExam() {
                this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'updateSchoolExam', {
                    'student_id': this.$store.state.modal.data.student_id,
                    'exam_id': this.$store.state.modal.data.id,
                    'schoolExam_id': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.schoolExam_id,
                    'schoolClass_id': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class.schoolClass_id,
                    'mainClassRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainClassRank,
                    'mainGradeRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainGradeRank,
                    'mainAreaRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.mainAreaRank,
                    'sumClassRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumClassRank,
                    'sumGradeRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumGradeRank,
                    'sumAreaRank': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.sumAreaRank,
                    'schoolScores': this.$parentInfo.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.schoolScores
                });
            },
        }
    }
</script>

<style scoped>
    .inputWidth {
        width: 180px !important;
    }
</style>
